/**
 * デバイスドライバーのインストール方法
 */

import { Link } from "react-router-dom";
import startMenu from "./img/drv_install_11_1.png";
import deviceManager from "./img/drv_install_11_2.png";
import updateDriver from "./img/drv_install_11_3.png";
import searchDriver from "./img/drv_install7.png";
import browseDriver from "./img/drv_install8.png";
import installDriver from "./img/drv_install9.png";
import finishInstall from "./img/drv_install10.png";
import confirmDriver from "./img/drv_install11.png";
import { Step } from "../components/Step";

/**
 *
 * @returns デバイスドライバーのインストール方法のJSX Element
 */
export const HowToInstallDeviceDriver: React.FC = () => {
  return (
    <div>
      <section className="c-section">
        <h2 className="p-heading-2">デバイスドライバーのインストール方法</h2>

        <Step
          step="1"
          text="CMCD-200の電源が入っている状態で、CMCD-200をお客様のお持ちのパソコンとUSBケーブル(別売)で接続してください。（接続後にCMCD-200の電源を入れても大丈夫です。）"
        />
        <Step
          step="2"
          text="デバイスマネージャーを表示します。スタートボタンを右クリック(タッチパネルの場合は長押し)し、「デバイスマネージャー」をクリックします。"
          image={startMenu}
          alt="スタートメニュー"
        />
        <Step
          step="3"
          text="ポート(COMとLPT)をダブルクリックすると、「USBシリアルデバイス」という項目があります。(USBシリアルデバイスが複数表示されている場合は、CMCD-200以外のUSB機器をパソコンから取り外してください。)"
          image={deviceManager}
          alt="デバイスマネージャー"
        />
        <Step
          step="4"
          text="USBシリアルデバイス(COM○)を右クリックし、「ドライバーの更新(P)」をクリックします。(COMの後の数字はお客さまの環境により異なります。)"
          image={updateDriver}
          alt="ドライバーの更新"
        />
        <Step
          step="5"
          text="「ドライバーの検索方法」の画面で「コンピューターを参照してドライバーソフトウェアを検索（R）」を選択してください。"
          image={searchDriver}
          alt="ドライバーの検索方法"
        />
        <Step
          step="6"
          text="「コンピューター上のドライバーを参照します。」の画面で「参照（R）」をクリックして、解凍したフォルダ「CMCD-200_Software」を選択して「OK」をクリックした後、「次へ（N）」をクリックしてください。"
          image={browseDriver}
          alt="コンピューター上のドライバーを参照します"
        />
        <Step
          step="7"
          text="「このデバイスソフトウェアをインストールしますか？」の画面で「インストール（I）」をクリックしてください。"
          image={installDriver}
          alt="このデバイスソフトウェアをインストールしますか"
        />
        <Step
          step="8"
          text="「ドライバーソフトウェアが正常にインストールされました。」の画面で「閉じる（C）」をクリックしてください。"
          image={finishInstall}
          alt="ドライバーソフトウェアが正常にインストールされました"
        />
        <Step
          step="9"
          text="デバイスマネージャーを開いてポート（COMとLPT）をダブルクリックすると「CMCD-200(CDC)(COM○○)」と表示されているのを確認してください。"
          image={confirmDriver}
          alt="デバイスマネージャーでの確認"
          point_text={<>ドライバーソフトウェアのインストール終了後は、
            <Link to="/cmcd-200/HowToUse">ロギングデータをパソコンで確認する</Link>
            を参考にして、ロギングデータをパソコンに取り込みます。</>}
        />
      </section>
    </div>
  );
};
